<template>
  <DropdownMenuGroup>
    <slot />
  </DropdownMenuGroup>
</template>

<script setup>
import { DropdownMenuGroup } from 'radix-vue'
</script>